import React from 'react'

export default function Page404() {
  return (
    <main className='bg-light height-keep'>
      <section className='container p-5'>
        <div className='row'>
          <div className='col'>
            <h2>404</h2>
          </div>
        </div>
      </section>
    </main>
  )
}
